
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/ski-accommodatie",
      function () {
        return require("private-next-pages/[region]/[resort]/ski-accommodatie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/ski-accommodatie"])
      });
    }
  